export default {"src":"/_next/static/media/kotakaful.bb752075.svg","height":23,"width":23};